import message from './message.json';

export default {
  message,
};